import React from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';
import DropdownInput from '@components/DropdownInput/DropdownInput';
import { SurgeonSelectionProps } from '@components/SurgeonSelection/SurgeonSelectionProps';
import { getFormattedName } from '@utilities/commonFunction';
import { DEFAULT_SELECTION_ALL } from '@utilities/constants';
import { useSurgeons } from '@utilities/hooks/useSurgeons/useSurgeons';

const useStyles = makeStyles(theme => ({
	root: {
		'width': '100%',
		'& .MuiInputLabel-root': {
			textTransform: 'unset',
			fontSize: '1rem',
			color: theme.palette.grey[700]
		},
		'& .MuiOutlinedInput-root': {
			height: '48px',
		},
		'& .MuiSelect-outlined.MuiSelect-outlined.MuiOutlinedInput-input': {
			paddingTop: theme.spacing(1.875),
			paddingBottom: theme.spacing(1.875),
			borderRadius: '4px',
		},
		'& .MuiAscensionDropdown-formControlDefault': {
			marginTop: theme.spacing(.5),
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.grey[700]
		},
		'&& .MuiOutlinedInput-notchedOutline > legend': {
			width: '0px',
			display: 'block',
		}
	},
}));

export const SurgeonSelection: React.FC<SurgeonSelectionProps> = ({ selectedSurgeon, setSelectedSurgeon, surgeons }) => {
	const classes = useStyles();
	const { surgeonByNpi } = useSurgeons();
	const prevSelectedSurgeon = surgeonByNpi[selectedSurgeon];

	const sortedSurgeonsWithAll = React.useMemo(() => {
		const allOption = {
			displayName: 'All',
			id: DEFAULT_SELECTION_ALL,
		};

		const surgeonsWithDisplayNames = surgeons.map(surgeon => ({
			...surgeon,
			displayName: getFormattedName(surgeon),
			id: surgeon.npi.toString(),
		}));

		const sortedSurgeons = surgeonsWithDisplayNames.sort((a, b) => a.displayName.localeCompare(b.displayName));
		return [allOption, ...sortedSurgeons];
	}, [surgeons]);

	const surgeonNotInList = selectedSurgeon && !surgeons.find(surgeon => surgeon.npi.toString() === selectedSurgeon);

	return (
		<DropdownInput
			value={selectedSurgeon}
			onChange={setSelectedSurgeon}
			fieldName="surgeon"
			label="Surgeons"
			className={classes.root}
		>
			{sortedSurgeonsWithAll.map(option =>
				<MenuItem key={option.id} value={option.id}>
					{option.displayName}
				</MenuItem>
			)}
			{surgeonNotInList && prevSelectedSurgeon &&
				<MenuItem key={prevSelectedSurgeon.npi} value={prevSelectedSurgeon.npi.toString()}>
					{getFormattedName(prevSelectedSurgeon)}
				</MenuItem>
			}
		</DropdownInput>
	);
};
